















import { Component, Vue } from "vue-property-decorator";
import NotificationSocleNotificationList from "@/components/admin/notification/SocleNotificationList.vue";
import EditNotificationSocle from "@/components/admin/notification/EditNotificationSocle.vue";
import SideNotification from "@/components/admin/notification/SideNotification.vue";

@Component({
    components: {
        NotificationSocle: NotificationSocleNotificationList,
        EditNotificationSocle,
        SideNotification,
    },
})
export default class SocleNotificationPage extends Vue {
    private isCreating = false;
    private reloadFlag = false;
    private notification: Notification | null = null;

    private edit(notification: Notification): void {
        this.isCreating = true;
        this.notification = notification;
    }

    private cancel(): void {
        this.isCreating = false;
        this.notification = null;
    }
}
